module.exports = __webpack_public_path__ + "static/media/ERDF_Col_Landscape.2025ce8a.png";